import { Preferences } from "@capacitor/preferences";

// This function return:
// null: if user tapped on "Don'show me again"
// true: if user tapped on "Enable"
// false: if user tapped on "Not now"
const askBiometricUsage = async () => {
    const { value } = await Preferences.get({ key: "biometricPreference" });
    switch(value){
        case("never"): return "never";
        case("true"): return true;
        case("false"): return false;
        default: return false;
    }
};
export default askBiometricUsage; 
